import { AnyAction } from 'redux';
import apiTypes from 'src/api/optimalprint-sdk.d';
import { ThunkDispatch } from 'redux-thunk';
import sendPostMessage from 'src/store/app/operation/sendPostMessage';
import { MESSAGE_TYPE } from 'src/store/app/types';
import { Store } from 'src/store/index';

const sendSetSpreadForegroundsPostMessageOperation = (
  scenes: apiTypes.AppBundle.Api.Response.Design.V3.DesignPublicEditorScenesListV3Response.Scene[],
) => (
  dispatch: ThunkDispatch<Store, undefined, AnyAction>,
) => sendPostMessage({
  type: MESSAGE_TYPE['design.spreadForegrounds'],
  data: scenes,
});
export default sendSetSpreadForegroundsPostMessageOperation;
